{
	"add-picture": "Add picture",
	"add-picture-info-text": "Picture of the product and the inner and outer packaging so we can determine the damage",
	"add-receipt": "Add receipt",
	"add-receipt-info-text": "Copy of the receipt. If the package is foreign a picture of the document is enough",
	"bankInfo": "Payment info",
	"content": "Content",
	"description-of-damage": "Description of the damage",
	"description-of-damage-placeholder": "Describe damages precisely...",
	"email-copy-of-report": "E-mail for a copy of the report",
	"error-heading": "There was an error!",
	"form-response": {
		"back-button": "Start again",
		"back-button-path": "/",
		"error": "Error",
		"text-error": "There was an error. We apologize for the inconvenience. Please try again later.",
		"text-success": "You're submisson was succesfull. A copy of the report has been sent to",
		"thank-you": "Thank you"
	},
	"handle-damaged-items": {
		"item-missing": "An item is missing from shipment",
		"receiver-keeps-item": "Receiver keeps the item",
		"receiver-keeps-item-info": "Compensation for 30-35% of product price",
		"sender-keeps-item": "Sender keeps the item",
		"sender-keeps-item-info": "Compensation for 30-35% of product price",
		"send-item-to-claims-department": "Send item to claims department",
		"send-item-to-claims-department-info": "Attention, compensation can not be processed until item arrives at claims department",
		"sender-received-item": "Sender received the item",
		"shipment-lost": "Shipment considered lost"
	},
	"how-to-handle": "How to handle damaged items",
	"info-about-damage": "Damage Info",
	"info-about-sender": "Sender info",
	"infoSenderReceiver": "Information about sender and recipient",
	"item-missing": "Missing items in delivery",
	"item-missing-text": "Applies to shipments with missing items",
	"receiver-foreign-address": "Receiver has a foreign address",
	"onlyIceland": "Attention: If the shipment did not get damaged in Iceland the report needs to be filed in the country it did.",
	"payer-has-foreign-bankaccount": "Foreign bank account",
	"report": "Report",
	"report-damage": "Report damage",
	"report-damage-text": "Applies to shipments that have been damaged.",
	"sender-foreign-address": "Sender does not have an Icelandic social ID",
	"sendReport": "Send",
	"shipment-missing": "Missing delivery",
	"shipment-missing-text": "Applies to shipments that have been lost. Can take up to 3-6 months to process.",
	"steps": {
		"step1": "Claim info",
		"step2": "Information",
		"step3": "Payment info",
		"step4": "Receipt"
	},
	"who-completes-report": "Who reports",
	"who-completes-report-options": {
		"employee": "Iceland Post employee",
		"other": "Other",
		"receiver": "Receiver",
		"sender": "Sender"
	},
	"info-text": {
		"1": "Maximum refund for a package is 22.500 kr.",
		"2": "When reporting damage, invoices must be included to show worth of shipment contents.",
		"3": "Refund will be processed once all required documents have been gathered.",
		"4": "The following are not applicable for refund: cash, jewelry, paintings and food."
	}
}
